import { FaDocker } from "react-icons/fa";
import { getCookie } from "./CommonFunctions";
import { API_PATH, APP_TYPE_COOKIE_NAME, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, MASTER_BRANCH, MASTER_CLIENTADDRESS, MASTER_CLIENTSERIESRATE, MASTER_IMPORT_RATE, MASTER_IMPORT_RATE_FOR_LOGISTIC, MMB, MMB_LIVE } from "./CommonVariable";
import reactRouterDom from "react-router-dom";


// ====================== load docket series =========================================
export async function loadDoketChargedBySeries(client) {

    try{
        // console.log("after checking to docket")
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        const columns = "client_code,series,amount";
        const beanName = "SeriesDocketBean";
        const tableName = "client_series_rate";
        const value = " where client_code='"+client+"'";

        const query = {
            "column":columns,
            "userKey":c[0],
            "beanname":beanName,
            "value":value
        };
        console.log(query);
        const formParam = {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body: new URLSearchParams({
                "query": JSON.stringify(query),
                "key":"checkService",
                "tableName":tableName
            })
        }
        const path = API_PATH + MASTER_CLIENTSERIESRATE + "getdata";

        const requestFetch = await fetch(path,formParam);
        const data = await requestFetch.json();
        const response = data?.[0]?.SeriesDocketBean ?? [];

        console.log("client series rate response:", response);

        return response;
    }catch(error){
        console.error("Failed to load series rate:", error);
        return [];
    }
}


// ==================== load rate from db =================================
export const loadRateFromDb=async(client,network,service,zoneCode,destCity)=>{
    try{
        if(!client){
            console.log("load Rate from Client not found");
            return [];
        }
        
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        const columns = "sno,client_code,network_code,service_code,client_type,rate_type,slab,add_limit,zone_type,zone_code,rate";
        const conditions = " where client_code='" + client + "' and network_code='"+network+"' and service_code = '"+service+"' and (zone_code='"+zoneCode+"' or zone_code='"+destCity+"') order by zone_type,rate_type,slab";
        const beanName = "ImportRateBean";
        const tableName = "rate_master_new";

        const path = API_PATH + MASTER_IMPORT_RATE + "getData";
        
        const query = {
            "value":conditions,
            "column":columns,
            "userKey":c[0],
            "beanname":beanName
        };
        const formParm = {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:new URLSearchParams({
                "query":JSON.stringify(query),
                "key":"checkService",
                "tableName":tableName
            })
        }

        const requestFetch = await fetch(path, formParm);
        console.log(requestFetch)
        try{
            const data = await requestFetch.json();
            const response = data?.[0]?.ImportRateBean ?? [];

            console.log(" client rate resposne ",  response);
            return response;
        }catch(err){
            console.log(err);
            console.log( await requestFetch.text());
        }
    }catch(error){
        console.error("Failed to load Rate from db:", error);
        return [];
    }
}

export const loadRatesFromDBForLogistic=async(client,network,service)=>{
    try{
        if(!client){
            console.log("client not found");
            return [];
        }

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        const query = {
            "column":"client_code, network_code, service_group_code as service_code, origin_zone, destination_zone, rate",
            "value":"where client_code='" + client + "' and network_code='"+network+"' and service_group_code = '"+service+"'",
            "beanname":"ImportRateBean",
            "userKey":c[0],
        }

        const path = API_PATH + MASTER_IMPORT_RATE_FOR_LOGISTIC  + "getdata";

        const formParam = {
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:new URLSearchParams({
                "query": JSON.stringify(query),
                "key":"checkService",
                "tableName":"rate_master_kg_new"
            })
        }

        const request = await fetch(path, formParam);
        const data = await request.json();
        const response = data?.[0]?.ImportRateBean ?? [];

        console.log(" client rate logistic resposne ",  response);
        return response;


    }catch(error){
        console.log(error);
        return [];
    }
}


export async function getClientAddressFromDb(clientCode) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    const userType = getCookie(APP_TYPE_COOKIE_NAME);
    const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let condition = '';
            let Data = "clientAddress";
            if(userType===MMB_LIVE){
                column = " client_code,gstin_no,address,city_code,zip_code,origin_pincode,state_code ";
                condition = " where active_status='Y' and client_code='"+clientCode+"' ";
                tableName = " client_master_address "
            }else if(userType===MMB) {
                    // column = " branch_cd,city,company_cd ";
                    // condition = " where  company_cd='" + brnCode + "'";
                    // tableName = " branch_master "
                    return
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,"value":condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CLIENTADDRESS + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.clientAddress || [];
            if (response.length > 0) {
                console.log("branch response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}
